import { render, staticRenderFns } from "./Frage_17.vue?vue&type=template&id=7f27b08e&"
import script from "./Frage_17.vue?vue&type=script&lang=js&"
export * from "./Frage_17.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports